// Язык интерфейса для контракта продукта (OsnovaContext.locale) — тот же модульный стор
// i18n, что видит useT: обе стороны перерисовываются одной сменой, второго состояния нет.
import { useSyncExternalStore } from "react";
import { getLocale, subscribeLocale } from "../i18n/i18n";
export function useLocale() {
    const locale = useSyncExternalStore(subscribeLocale, getLocale);
    return locale === "en" ? "en" : "ru";
}
